/* tslint:disable */
import { Injectable } from '@angular/core';
import { User } from '../../models/User';
import { Institutions } from '../../models/Institutions';
import { Sector } from '../../models/Sector';
import { Report } from '../../models/Report';
import { PopulationCount } from '../../models/PopulationCount';
import { ReportsMedia } from '../../models/ReportsMedia';
import { FundAccount } from '../../models/FundAccount';
import { PopulationCategory } from '../../models/PopulationCategory';
import { County } from '../../models/County';
import { SubCounty } from '../../models/SubCounty';
import { FundsAccount } from '../../models/FundsAccount';
import { VoteHeads } from '../../models/VoteHeads';
import { VoteHeadAllocation } from '../../models/VoteHeadAllocation';
import { AnnualBreakdown } from '../../models/AnnualBreakdown';
import { FundsAllocated } from '../../models/FundsAllocated';
import { FundsExpenditure } from '../../models/FundsExpenditure';
import { UserAccount } from '../../models/UserAccount';
import { SectorType } from '../../models/SectorType';
import { SectorCategory } from '../../models/SectorCategory';
import { InstitutionVersion } from '../../models/InstitutionVersion';
import { Document } from '../../models/Document';
import { Temp } from '../../models/Temp';
import { FundsBudgeted } from '../../models/FundsBudgeted';
import { AccountSupportFund } from '../../models/AccountSupportFund';
import { AccountIncomeSource } from '../../models/AccountIncomeSource';
import { Constituency } from '../../models/Constituency';
import { FeedBack } from '../../models/FeedBack';
import { NewsFeed } from '../../models/NewsFeed';
import { Files } from '../../models/Files';
import { FileManager } from '../../models/FileManager';
import { Analytics } from '../../models/Analytics';
import { ServiceCharterGroup } from '../../models/ServiceCharterGroup';
import { Sample } from '../../models/Sample';
import { BudgetBreakdownItem } from '../../models/BudgetBreakdownItem';
import { ReportComment } from '../../models/ReportComment';
import { ServiceCharterGrouping } from '../../models/ServiceCharterGrouping';
import { DigitalTool } from '../../models/DigitalTool';
import { Survey } from '../../models/Survey';
import { S } from '../../models/S';
import { Project } from '../../models/Project';
import { ProjectFunder } from '../../models/ProjectFunder';
import { Image } from '../../models/Image';
import { Milestone } from '../../models/Milestone';
import { Ward } from '../../models/Ward';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    User: User,
    Institutions: Institutions,
    Sector: Sector,
    Report: Report,
    PopulationCount: PopulationCount,
    ReportsMedia: ReportsMedia,
    FundAccount: FundAccount,
    PopulationCategory: PopulationCategory,
    County: County,
    SubCounty: SubCounty,
    FundsAccount: FundsAccount,
    VoteHeads: VoteHeads,
    VoteHeadAllocation: VoteHeadAllocation,
    AnnualBreakdown: AnnualBreakdown,
    FundsAllocated: FundsAllocated,
    FundsExpenditure: FundsExpenditure,
    UserAccount: UserAccount,
    SectorType: SectorType,
    SectorCategory: SectorCategory,
    InstitutionVersion: InstitutionVersion,
    Document: Document,
    Temp: Temp,
    FundsBudgeted: FundsBudgeted,
    AccountSupportFund: AccountSupportFund,
    AccountIncomeSource: AccountIncomeSource,
    Constituency: Constituency,
    FeedBack: FeedBack,
    NewsFeed: NewsFeed,
    Files: Files,
    FileManager: FileManager,
    Analytics: Analytics,
    ServiceCharterGroup: ServiceCharterGroup,
    Sample: Sample,
    BudgetBreakdownItem: BudgetBreakdownItem,
    ReportComment: ReportComment,
    ServiceCharterGrouping: ServiceCharterGrouping,
    DigitalTool: DigitalTool,
    Survey: Survey,
    S: S,
    Project: Project,
    ProjectFunder: ProjectFunder,
    Image: Image,
    Milestone: Milestone,
    Ward: Ward,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/services/custom/SDKModels.ts